import 'core-js/es'
import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import React from "react";
import ReactDOM from "react-dom";
import Uploader from "./content";
import "./index.css";
import BasicLayout from "./layout";

const getQueryVariable = (variable) => {
  var query = window.location.search.substring(1);
  var vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (pair[0] === variable) {
      var value = decodeURIComponent(pair[1]);
      return value;
    }
  }
  return null;
};
if (getQueryVariable("linux") === "1") {
  window.document.libIsLinux = true;
}
ReactDOM.render(
  <div className="main">
    <BasicLayout>
      <Uploader />
    </BasicLayout>
  </div>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
